// import React, { useEffect, useState } from "react";
// import { Container, Table, Button, Badge, Spinner, Alert } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import { io } from "socket.io-client";

// const OrdersPage = ({ isAdmin = false }) => {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const navigate = useNavigate();

//     // Initialize socket connection
//     const socket = io("https://madhusewingmachines.com", {
//         autoConnect: false,
//         withCredentials: true
//     });

//     const fetchOrders = async () => {
//         try {
//             const endpoint = isAdmin
//                 ? "https://madhusewingmachines.com/api/orders"
//                 : "https://madhusewingmachines.com/api/orders/my-orders";

//             const response = await fetch(endpoint, {
//                 headers: {
//                     "Authorization": `Bearer ${localStorage.getItem("token")}`
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error(response.status === 401
//                     ? "Please login to view orders"
//                     : "Failed to fetch orders");
//             }

//             const { data } = await response.json();
//             setOrders(data || []);
//         } catch (err) {
//             setError(err.message);
//             if (err.message.includes("401")) {
//                 navigate("/login");
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchOrders();

//         // Socket.io connection for real-time updates
//         socket.connect();

//         socket.on("orderUpdated", (updatedOrder) => {
//             setOrders(prevOrders =>
//                 prevOrders.map(order =>
//                     order._id === updatedOrder._id ? updatedOrder : order
//                 )
//             );
//         });

//         socket.on("connect_error", (err) => {
//             console.error("Socket connection error:", err);
//         });

//         return () => {
//             socket.off("orderUpdated");
//             socket.disconnect();
//         };
//     }, [isAdmin]);

//     const getStatusBadge = (status) => {
//         const statusMap = {
//             "pending": "warning",
//             "processing": "warning",
//             "shipped": "info",
//             "delivered": "success",
//             "cancelled": "danger"
//         };
//         return statusMap[status.toLowerCase()] || "secondary";
//     };

//     if (loading) {
//         return (
//             <Container className="py-5 text-center">
//                 <Spinner animation="border" />
//                 <p className="mt-2">Loading orders...</p>
//             </Container>
//         );
//     }

//     if (error) {
//         return (
//             <Container className="py-5">
//                 <Alert variant="danger">
//                     <strong>Error:</strong> {error}
//                     <div className="mt-3">
//                         <Button variant="primary" onClick={fetchOrders}>
//                             Retry
//                         </Button>
//                     </div>
//                 </Alert>
//             </Container>
//         );
//     }

//     return (
//         <Container className="py-5">
//             <h2 className="mb-4">{isAdmin ? "📦 All Orders" : "📦 My Orders"}</h2>

//             {orders.length === 0 ? (
//                 <div className="text-center py-5">
//                     <p>{isAdmin ? "No orders found" : "You have no orders yet!"}</p>
//                     {!isAdmin && (
//                         <Button onClick={() => navigate("/")}>
//                             Start Shopping 🛍️
//                         </Button>
//                     )}
//                 </div>
//             ) : (
//                 <Table striped bordered hover responsive>
//                     <thead>
//                         <tr>
//                             <th>Order #</th>
//                             {isAdmin && <th>Customer</th>}
//                             <th>Date</th>
//                             <th>Status</th>
//                             <th>Total</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {orders.map(order => (
//                             <tr key={order._id}>
//                                 <td>{order.orderNumber || order._id.substring(0, 8)}</td>
//                                 {isAdmin && (
//                                     <td>
//                                         {order.user?.name || "Guest"}
//                                         <br />
//                                         <small>{order.user?.email || ""}</small>
//                                     </td>
//                                 )}
//                                 <td>{new Date(order.createdAt).toLocaleDateString()}</td>
//                                 <td>
//                                     <Badge bg={getStatusBadge(order.status)}>
//                                         {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
//                                     </Badge>
//                                 </td>
//                                 <td>₹{order.total?.toLocaleString()}</td>
//                                 <td>
//                                     <Button
//                                         size="sm"
//                                         onClick={() => navigate(isAdmin
//                                             ? `/admin/orders/${order._id}`
//                                             : `/orders/${order._id}`
//                                         )}
//                                     >
//                                         Details
//                                     </Button>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>
//             )}
//         </Container>
//     );
// };

// export default OrdersPage;




import { useEffect, useState } from "react";
import { Container, Table, Button, Badge, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const OrdersPage = ({ isAdmin = false }) => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const fetchOrders = async () => {
        try {
            const endpoint = "https://madhusewingmachines.com/api/orders";
            const response = await axios.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            setOrders(response.data.data || []);
        } catch (err) {
            setError("Failed to fetch orders. Please try again.");
            if (err.response?.status === 401) navigate("/login");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, [isAdmin]);

    const checkOrderStatus = async (orderId) => {
        try {
            const response = await axios.get(`https://madhusewingmachines.com/api/orders/${orderId}/status`);
            alert(`Order Status: ${response.data.status}`);
        } catch (error) {
            alert("Failed to check order status.");
        }
    };

    const downloadInvoice = (orderId) => {
        window.open(`https://madhusewingmachines.com/api/orders/${orderId}/invoice`, "_blank");
    };

    if (loading) {
        return (
            <Container className="py-5 text-center">
                <Spinner animation="border" />
                <p className="mt-2">Loading orders...</p>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="py-5">
                <Alert variant="danger">
                    <strong>Error:</strong> {error}
                    <div className="mt-3">
                        <Button variant="primary" onClick={fetchOrders}>
                            Retry
                        </Button>
                    </div>
                </Alert>
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <h2 className="mb-4">{isAdmin ? "📦 All Orders" : "📦 My Orders"}</h2>

            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Order #</th>
                        {isAdmin && <th>Customer</th>}
                        <th>Date</th>
                        <th>Status</th>
                        <th>Total</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order._id}>
                            <td>{order._id.substring(0, 8)}</td>
                            {isAdmin && <td>{order.user?.name || "Guest"}</td>}
                            <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                            <td><Badge bg="info">{order.status}</Badge></td>
                            <td>₹{order.total?.toLocaleString()}</td>
                            <td>
                                <Button size="sm" onClick={() => checkOrderStatus(order._id)}>Check Status</Button>{' '}
                                <Button size="sm" onClick={() => downloadInvoice(order._id)}>Download Invoice</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default OrdersPage;



